import { SecuredHomeComponent } from './secured-home/secured-home.component';
import { CanActivateViaAuthGuard } from '../shared/guards/can-activate-via-auth-guard';
import { LogoutComponent } from './logout/logout.component';
import { CanActivateViaGuestGuard } from '../shared/guards/can-activate-via-guest-guard';
import { LoginComponent } from './login/login.component';
import { Routes } from '@angular/router';
import { ExternalLoginExpiredComponent } from './external-login-expired/external-login-expired.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [ CanActivateViaGuestGuard ]
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [ CanActivateViaAuthGuard ]
  },
  {
    path: 'secured',
    component: SecuredHomeComponent
  },
  {
    path: 'external-login-expired',
    component: ExternalLoginExpiredComponent,
    canActivate: [ CanActivateViaGuestGuard ]
  }
];



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/auth/auth.routes.ts